import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import React, { useState } from 'react'
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { addWorkingGroupApi, updateWorkingGroupeApi } from '../apiService';
import { checkApiStatus } from '../../../../utils';
import { enqueueSnackbar } from 'notistack';
import { regexConstants } from '../../../../constants/regEx';
import { trackActivity } from "../../../../utils/mixpanel";
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';

const WorkingGroupsCRU = ({ workingGroupCUR, modeType, onToggleModal, getResponseBack, params }) => {
    const [wrgData, setWrgData] = useState(workingGroupCUR?.data);
    const [error, setError] = useState({});
    const [loading, setLoading] = useState(false);

    const addEditWorkingGroup = () => {
        let validationInputs = {};
        validationInputs = {
            name: wrgData?.name?.trim() ? "" : "Please enter Name",
        };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (wrgData?.id) {
                globalPutService(updateWorkingGroupeApi({ asset_slug: wrgData?.slug }), wrgData)
                    .then((response) => {
                        if (checkApiStatus(response)) {
                            setLoading(false);
                            onToggleModal();
                            getResponseBack();
                            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Working Group`, success_msg: response?.data?.message, item_id: wrgData?.id, payload: wrgData, response: response?.data });
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Working Group`, success_msg: response?.data?.message, item_id: wrgData?.id, payload: wrgData, response: response?.data });
                        }
                    })
            } else {
                globalPostService(addWorkingGroupApi(), wrgData)
                    .then((response) => {
                        if (checkApiStatus(response)) {
                            setLoading(false);
                            onToggleModal();
                            getResponseBack();
                            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Added', { page_title: `Add Working Group`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: wrgData, response: response?.data });
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Added', { page_title: `Add Working Group`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: wrgData, response: response?.data });
                        }
                    })
            }
        } else {
            setError(validationInputs)
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Working Group`, error_msg: validationInputs, })
        }
    }

    const onFieldChange = (keyParam, value) => {
        setWrgData({ ...wrgData, [keyParam]: value });

    }
    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Settings Working Group`, page_type: page_type, })
    }

    return (
        <>
            <Dialog aria-labelledby="customized-dialog-title" className="setting-clause-dialog" maxWidth="md" fullWidth open={true}>
                <DialogTitle sx={{ m: 0, p: 2 }} style={{ position: 'sticky' }} className='dialog-header'>
                    <Typography sx={{ marginLeft: '10px' }}>
                        {modeType === "add" ? "Add Working Group" : modeType === "edit" ? "Edit Working Group" : "View Working Group"}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                required
                                id="name"
                                label="Name"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100} }}
                                disabled={modeType === "view"}
                                value={wrgData?.name || ""}
                                error={error?.name || false}
                                helperText={error?.name || ''}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? e.target.value?.length <= 100 ? onFieldChange("name", e.target.value.trimStart()) : null : e.preventDefault()}
                                onFocus={() => onRestErrorKey("name")}
                            />
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Remarks' value={wrgData?.remarks || ""} />
                        </Grid> :
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    rows={3}
                                    id="remarks"
                                    label="Remarks"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    fullWidth
                                    multiline
                                    disabled={modeType === "view"}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    value={wrgData?.remarks || ""}
                                    onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault() }}
                                />
                            </Grid>}
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ marginRight: '15px' }}>
                    <Button className='cancel-btn' disabled={loading} variant="outlined" size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null : <Button variant="contained" size='small' className="btn-primary" onClick={() => { addEditWorkingGroup(); handleItemClicked('Save Button'); }}>{loading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}</Button>}

                </DialogActions>
            </Dialog>
        </>
    )
}

export default WorkingGroupsCRU;